import React, { useState } from "react";

import CustomCheckbox from "src/app/components/CustomCheckbox/CustomCheckbox";

export default function AudiencesResultsCheckbox({
  influencer,
  selectedInfluencers,
  selectUserClick,
  handleRangeSelect,
  lastSelectedIndex,
  setLastSelectedIndex,
  isPreselected,
  index,
}) {
  const [shouldShowCheckbox, setShouldShowCheckbox] = useState(false);
  const checked =
    selectedInfluencers.indexOf(influencer.userId) > -1 || isPreselected;

  const handleClick = (e) => {
    if (isPreselected) return;

    // Prevent native checkbox/label toggling so selection is handled exactly once
    // by our controlled Redux flow (prevents double-toggle / missed-toggle behavior).
    if (e?.preventDefault) {
      e.preventDefault();
    }

    if (e.shiftKey && lastSelectedIndex !== null) {
      handleRangeSelect(lastSelectedIndex, index, !checked);
    } else {
      selectUserClick(influencer.userId, influencer.profileUrl);
    }
    setLastSelectedIndex(index);
  };

  return (
    <div
      className="audiences-results-checkbox"
      role="checkbox"
      aria-checked={checked}
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          handleClick(e);
        }
      }}
      onMouseEnter={() => {
        setShouldShowCheckbox(true);
      }}
      onMouseLeave={() => {
        setShouldShowCheckbox(false);
      }}
    >
      {!checked && !shouldShowCheckbox ? (
        <span className="audiences-results-checkbox__index">{index + 1}</span>
      ) : (
        <CustomCheckbox
          id={influencer.userId}
          name={`user-${influencer.userId}`}
          checked={checked}
          onChange={(e) => e.stopPropagation()}
          disabled={isPreselected}
        />
      )}
    </div>
  );
}
